
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tools/link-checker",
      function () {
        return require("private-next-pages/[locale]/tools/link-checker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tools/link-checker"])
      });
    }
  